import {
  REQUEST_SHIP_AVAILABLE_DATES,
  RECEIVE_SHIP_AVAILABLE_DATES,
  SHIP_AVAILABLE_DATES_ERROR
} from '../actions/availableDates'

const initialState = {
  isLoading: false,
  hasErrors: false,
  dates: null
}
const availableSailingDates = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SHIP_AVAILABLE_DATES:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVE_SHIP_AVAILABLE_DATES:
      return Object.assign({}, state, {
        dates: action.payload,
        isLoading: false,
        hasErrors: false
      })
    case SHIP_AVAILABLE_DATES_ERROR:
      return Object.assign({}, state, {
        hasErrors: true
      })
    default:
      return state
  }
}

export default availableSailingDates
